<script setup>
import { computed } from "vue";
import { useAuth0 } from "@auth0/auth0-vue";

const { logout, isAuthenticated, user } = useAuth0();

const isAdmin = computed(() => {
  const roles = user.value?.['https://blything.co.uk/roles'] || [];
  return roles.includes('Admin');
});

const handleLogout = () => {
  logout({ logoutParams: { returnTo: window.location.origin } });
};
</script>

<template>
  <div>
    <div class="header grid-x">
      <div class="grid-x cell align-middle small-offset-0 small-12 medium-offset-1 medium-10 large-offset-1 large-10 white-section">
        
        <!-- MOBILE / TABLET LOGO (Shows up to 1023px) -->
        <div id="head-logo-mobile" class="hide-for-large"></div>
        
        <!-- DESKTOP LOGO (Shows 1024px and up) -->
        <div id="head-logo" class="cell large-4 show-for-large"></div>
        
        <!-- DESKTOP MENU (Shows 1024px and up) -->
        <div class="cell large-8 show-for-large menu-column">
          <ul v-show="isAuthenticated" id="head-menu-list">
            <router-link to="/home">
              <li>
                <font-awesome-icon :icon="['fas', 'house']" />
                <span>Home</span>
              </li>
            </router-link>

            <router-link to="/profile">
              <li>
                <font-awesome-icon :icon="['fas', 'user']" />
                <span>Profile</span>
              </li>
            </router-link>

            <!-- Admin Link -->
            <router-link v-if="isAdmin" to="/admin">
              <li>
                <font-awesome-icon :icon="['fas', 'users-gear']" />
                <span>Admin</span>
              </li>
            </router-link>

            <a @click.prevent="handleLogout" href="#">
              <li>
                <font-awesome-icon :icon="['fas', 'arrow-right-from-bracket']" />
                <span>Logout</span>
              </li>
            </a>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.white-section {
  border-radius: 0 0 16px 16px;
}
</style>

<style lang="scss">
@use "@/assets/styles/components/header";
</style>